<template>
  <div class="container">
    <div class="favortie" style="display: table-row; background: #0a0a0a">
      <a style="display: table-cell;
    position: relative;
    padding: 10px 23px;
    height: 50px;
    border-left: 1px solid transparent;
    background-clip: padding-box;
    vertical-align: top;">
        <div style="display: flex;
    height: 20px;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    font-size: 12px;">
          <span style="display: inline-block;
    flex-shrink: 1;
    -webkit-user-select: text;
    user-select: text;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;">
            AAAA
          </span>
          <span style="flex-grow: 1;
    overflow: visible;
    white-space: nowrap;
    -webkit-user-select: text;
    user-select: text;
    text-align: right;">
            247.58
          </span>
        </div>
        <div style="width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 22px;
    line-height: 26px;
}">
EEEE
        </div>
      </a>
    </div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="panel panel-default">
          <div class="panel-heading">

          </div>
          <div class="panel-body">
            I'm an example component!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log('Component mounted.')
  }
}
</script>
